export const actionTypes = {
  setvariables: "setvariables",
};
const initstate = {
  variables: {},
};
export const BreReducer = (state = initstate, action) => {
  switch (action.type) {
    case actionTypes.setvariables:
      return { variables: action.payload };
    default:
      return state;
  }
};
export const BreActions = {
  
  setvariables: (variables) => ({ type: actionTypes.setvariables, payload: variables }),
};
